import { render } from "./ViewPdf.vue?vue&type=template&id=01aecf48&scoped=true"
import script from "./ViewPdf.vue?vue&type=script&lang=js"
export * from "./ViewPdf.vue?vue&type=script&lang=js"

import "./ViewPdf.vue?vue&type=style&index=0&id=01aecf48&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01aecf48"]])

export default __exports__